module.exports = "https://www.gc-qa.gnp.com.mx/9d33c89cfac93b48221fbeb3794ec3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/auto3.png
// module id = 1800
// module chunks = 0